// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customForm .v-text-field>.v-input__control>.v-input__slot:after,.customForm .v-text-field>.v-input__control>.v-input__slot:before{border-style:none!important}", ""]);
// Exports
module.exports = exports;
